/**
 * Get GA code
 */
export const getGoogleAnalyticsAcccount = () => {

  return 'UA-33182537-1';

};
